import { useState } from "react";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";

export default function LoginPage() {
  const { signIn } = useAuth();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!password) {
      toast.error("Password is required");
      return;
    }
    setSubmitting(true);
    try {
      await signIn({ username: username.trim() || "admin", password });
      toast.success("Signed in");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sign in failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 p-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          <div className="h-11 w-11 rounded-xl bg-neutral-900 text-white flex items-center justify-center mb-4">
            <Lock className="h-5 w-5" />
          </div>
          <h1 className="text-xl font-semibold tracking-tight text-neutral-900">
            A6 Inventory Label Generator
          </h1>
          <p className="text-sm text-neutral-500 mt-1">
            Internal tool — sign in to continue
          </p>
        </div>

        <form
          onSubmit={onSubmit}
          className="rounded-xl border border-neutral-200 bg-white p-6 space-y-4 shadow-sm"
          data-testid="login-form"
        >
          <div className="space-y-2">
            <Label htmlFor="login-username">Username</Label>
            <Input
              id="login-username"
              data-testid="login-username"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="login-password">Password</Label>
            <Input
              id="login-password"
              data-testid="login-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <Button
            type="submit"
            className="w-full"
            disabled={submitting}
            data-testid="login-submit"
          >
            {submitting ? "Signing in..." : "Sign in"}
          </Button>
        </form>

        <p className="text-[11px] text-neutral-400 text-center mt-6">
          Credentials are configured via environment variables
        </p>
      </div>
    </div>
  );
}
